export default function createLogContext({
	host,
	tagName: componentName,
	componentId,
	level,
	error,
	docs,
	origin,
	module,
	message,
	postfix
}) {
	const tempHost = host ? host : {};
	const {
		tagName = null,
		nowId = null,
		__DO_NOT_USE_OR_YOU_WILL_BE_FIRED_BY_YOUR_PARENT__ = null,
		nowLoggingLevels = null
	} = tempHost;

	const logContext = {
		componentName: tagName ? tagName : componentName,
		componentId: nowId ? nowId : componentId,
		parentComponentId: __DO_NOT_USE_OR_YOU_WILL_BE_FIRED_BY_YOUR_PARENT__,
		level,
		error,
		docs,
		origin,
		module,
		postfix,
		nowLoggingLevels
	};

	logContext.logMessage = getLogMessage(logContext, message);
	return logContext;
}

const getLogMessage = (logContext, message) => {
	const {componentName, componentId, docs, error, postfix, module, origin} = logContext;
	const componentMsg = componentName
		? `<${componentName.toLowerCase()} ${componentId ? `component-id="${componentId}"` : ''}/>`
		: '';

	let startMessage = '';
	if (componentMsg && origin)
		startMessage = `For component ${componentMsg} with origin '${origin}': `;
	else if (componentMsg) startMessage = `For component ${componentMsg}: `;
	else if (origin) startMessage = `At origin '${origin}': `;

	return `${module} ${startMessage}${message}${error ? `\n${error.stack}` : ''}${
		docs ? `\nDocumentation: ${docs}` : `\n${postfix}`
	}`;
};
